import React, { Component } from 'react';

import Loading from 'Components/Reusable/Loading/Loading.component';

class LoadingContainer extends Component {
  render() {
    return <Loading />;
  }
}

export default LoadingContainer;
